export const texteATrousData = {
    text: "Selon l'Agence Européenne du Médicament: L'ajout de [[1]] n'est pas considéré comme [[2]] s'il a un impact [[3]] significatif sur l'immunogénicité contre les sérotypes inclus dans les [[4]]. Il est crucial d'offrir une protection [[5]] entre la [[6]] et la [[7]] (entre [[8]] et [[9]] mois). En effet, le pic de [[10]] à pneumocoques se situe entre 4 et 11 mois.",
    trous: [
        { index: 1, position: 0, answer: 'maximale', isCorrect: false },
        { index: 2, position: 0, answer: 'bactérie', isCorrect: false },
        { index: 3, position: 4, answer: 'VPC historiques', isCorrect: true },
        { index: 4, position: 1, answer: 'sérotypes', isCorrect: true },
        { index: 5, position: 9, answer: 'onze', isCorrect: true },
        { index: 6, position: 2, answer: 'bénéfique', isCorrect: true },
        { index: 7, position: 10, answer: 'méningite', isCorrect: true },
        { index: 8, position: 3, answer: 'négatif', isCorrect: true },
        { index: 9, position: 0, answer: 'Vaccins', isCorrect: false },
        { index: 10, position: 8, answer: 'quatre', isCorrect: true },
        { index: 11, position: 0, answer: 'douze', isCorrect: false },
        { index: 12, position: 0, answer: 'otite', isCorrect: false },
        { index: 13, position: 5, answer: 'suffisante', isCorrect: true },
        { index: 14, position: 0, answer: 'trois', isCorrect: false },
        { index: 15, position: 6, answer: 'primovaccination', isCorrect: true },
        { index: 16, position: 7, answer: 'dose de rappel', isCorrect: true },
    ],
};
